import { getRequest, postRequest, patchRequest, deleteRequest } from '../../services/apiService';
import { getServiceVerificationsAction, getServiceVerificationsCountAction, getServiceVerificationAction } from '../reducers/ServiceVerificationReducer';

const route_path = 'serviceverification'

export const getAllServiceVerifications = ({ page, limit, search, status, columnName }) => async (dispatch) => {
  try {
    const response = await getRequest(`${route_path}/list`, { page, limit, search, status, columnName });
    dispatch(getServiceVerificationsAction(response));
  } catch (error) {
    console.error("Error fetching properties:", error);
    throw error;
  }
};

export const getAllServiceVerificationCount = ({ page, limit, search, status }) => async (dispatch) => {
  try {
    const response = await getRequest(`${route_path}/count`, { page, limit, search, status });
    dispatch(getServiceVerificationsCountAction(response));
  } catch (error) {
    console.error("Error fetching properties:", error);
    throw error;
  }
};

export const getServiceVerificationsById = (serviceVerificationsId) => async (dispatch) => {
  try {
    
    const response = await getRequest(`${route_path}/${serviceVerificationsId}`);
    dispatch(getServiceVerificationAction(response));
  } catch (error) {
    console.error(`Error fetching serviceVerifications with ID ${serviceVerificationsId}:`, error);
    throw error;
  }
};

export const createServiceVerifications = (serviceVerificationsData) => async (dispatch) => {
  try {
    const response = await postRequest(`${route_path}/add`, serviceVerificationsData);
  } catch (error) {
    console.error("Error creating serviceVerifications:", error);
    throw error;
  }
};

export const updateServiceVerifications = (serviceVerificationsId, serviceVerificationsData) => async (dispatch) => {
  try {
    
    const response = await patchRequest(`${route_path}/edit/${serviceVerificationsId}`, serviceVerificationsData);
  } catch (error) {
    console.error(`Error updating serviceVerifications with ID ${serviceVerificationsId}:`, error);
    throw error;
  }
};

export const deleteServiceVerifications = (serviceVerificationsId) => async (dispatch) => {
  try {
    const response = await deleteRequest(`${route_path}/delete/${serviceVerificationsId}`);
  } catch (error) {
    console.error(`Error deleting serviceVerifications with ID ${serviceVerificationsId}:`, error);
    throw error;
  }
};

export const addServiceVerificationsData = () => async (dispatch) => {
  try {
    const response = await getRequest(`${route_path}/add/requireddata`)
  } catch (error) {
    console.error("Error while getting add serviceVerifications data:", error);
    throw error;
  }
}
